import React, { Ref, useCallback, useEffect } from 'react';
import Supercluster, { ClusterProperties } from 'supercluster';
import { FeaturesClusterMarker } from './FeaturesClusterMarker';
import FeatureMarker from './FeatureMarker';
import { useSupercluster } from '../hooks/use-supercluster.ts';
import { cluster } from 'd3';
//import {Feature, FeatureCollection, GeoJsonProperties, Point} from 'geojson';


const superclusterOptions = {
  extent: 256,
  radius: 80,
  maxZoom: 22
};

export const ClusteredMarkers = ({
  geojson,
  setNumClusters,
  setInfowindowData,
  setFilteredrows,
  overSiteId,
  activeSiteId
}) => {
  const { clusters, getLeaves } = useSupercluster(geojson, superclusterOptions);

  useEffect(() => {
    setNumClusters(clusters.length);
  }, [setNumClusters, clusters.length]);

  useEffect(() => {
    let rows = [];
    clusters.forEach((cluster) => {
      const clusterProperties = cluster.properties;
      const isCluster = clusterProperties.cluster;
      console.log(clusterProperties);
      if (isCluster) {
        const leaves = getLeaves(clusterProperties.cluster_id);
        leaves.forEach((leave) => {
          rows.push(leave);
        });
      }
      else {
        rows.push(cluster);
      }
    });
    setFilteredrows(rows);
  }, [clusters]);


  const handleClusterClick = useCallback(
    (marker, clusterId) => {
      const leaves = getLeaves(clusterId);
      setInfowindowData({ anchor: marker, features: leaves });
    },
    [getLeaves, setInfowindowData]
  );

  const handleMarkerClick = useCallback(
    (marker, featureId) => {
      const feature = clusters.find(
        feat => feat.id === featureId
      );
      setInfowindowData({ anchor: marker, features: [feature] });
    },
    [clusters, setInfowindowData]
  );

  const getClusterEnergy = (clusterid) => {
    const leaves = getLeaves(clusterid);
    let energy = "none";
    leaves.forEach((leave) => {
      if (energy === 'none') {
        energy = leave.properties.energy;
      }
      else if (energy !== leave.properties.energy) {
        energy = 'multi';
        return;
      }
    })
    return energy;
  }

  return (
    <>
      {clusters.map(feature => {
        const [lng, lat] = feature.geometry.coordinates;
        console.log(feature.geometry.coordinates);

        const clusterProperties = feature.properties;
        const isCluster = clusterProperties.cluster;

        return isCluster ? (
          <FeaturesClusterMarker
            key={feature.id}
            clusterId={clusterProperties.cluster_id}
            position={{ lat, lng }}
            size={clusterProperties.point_count}
            sizeAsText={String(clusterProperties.point_count_abbreviated)}
            onMarkerClick={handleClusterClick}
            energy={getClusterEnergy(clusterProperties.cluster_id)}
            leaves={getLeaves(clusterProperties.cluster_id)}
            overSiteId={overSiteId}
            activeSiteId={activeSiteId}
          />
        ) : (
          <FeatureMarker
            key={feature.id}
            properties={feature.properties}
            featureId={feature.id}
            position={{ lat, lng }}
            onMarkerClick={handleMarkerClick}
            specialcolor={feature.specialcolor}
            overSiteId={overSiteId}
            activeSiteId={activeSiteId}
          />
        );
      })}
    </>
  );
};
